import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import { setTop10Percentage } from "@pages/Statistics/store";

import { top10SubFamiliesSelection } from "@pages/Statistics/NewProducts/signals";

import { useResource } from "@hooks/useResource";

import {
    getTypeParam,
    getStringsArrayUniqueValues,
    getAdvancedPeriodStringParam,
    getRoundedArrayNumbers,
} from "@helpers/general";

import ErrorPage from "@components/Common/ErrorPage";
import CustomErrorBoundary from "@components/Common/CustomErrorBoundary";
import DonutChart from "@pages/Statistics/CommonCharts/DonutChart";
import LegendPopoverWrapper from "@pages/Statistics/CommonCharts/DonutChart/LegendPopoverWrapper";

export default function Top10SubFamiliesCol() {
    const { t } = useTranslation();

    const { period, type, advancedDate, selections } = useSelector(
        (state: any) => state
    );

    const [data, setData] = React.useState<number[]>([]);
    const [labels, setLabels] = React.useState<string[]>([]);

    const {
        resourceData: { data: top10SubFamiliesData },
        error,
    } = useResource(
        `${
            process.env.REACT_APP_API_V1_URL
        }/statistics/products/percentage-sub-families?type=${getTypeParam(
            type
        )}&${getAdvancedPeriodStringParam(period, advancedDate)}${
            selections.designation && selections.designation !== "my_favorites"
                ? `&selected=${selections.designation}`
                : ""
        }${
            top10SubFamiliesSelection.value !== ""
                ? `&sub-families=${top10SubFamiliesSelection.value}`
                : ""
        }`
    );

    React.useEffect(() => {
        let localSeries: number[] = [];
        let localFamilies: string[] = [];

        top10SubFamiliesData?.forEach((item: any) => {
            localSeries.push(item.value);
            localFamilies.push(item.designation);
        });

        setData(
            getRoundedArrayNumbers(localSeries.filter((item) => item !== 0))
        );
        setLabels(
            getStringsArrayUniqueValues(
                localFamilies.length > 0
                    ? localFamilies.map((item) => t(item))
                    : [t("No data")]
            )
        );
        setTop10Percentage(localSeries, "subFamilies");
    }, [top10SubFamiliesData, t]);

    const donutChartTop10SubFamiliesData = {
        data,
        labels:
            labels.length > 0
                ? getStringsArrayUniqueValues(labels).map((label) => t(label))
                : [t("No data")],
    };

    return (
        <React.Fragment>
            {error ? (
                <ErrorPage />
            ) : (
                <CustomErrorBoundary>
                    <DonutChart
                        title={t("Top 10 sub-families")}
                        data={donutChartTop10SubFamiliesData}
                    >
                        <LegendPopoverWrapper
                            title={t("Top 10 sub-families")}
                            labels={labels || []}
                        />
                    </DonutChart>
                </CustomErrorBoundary>
            )}
        </React.Fragment>
    );
}
